import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Experience} from '../../../interfaces/experience';
import {
  COMING_SOON,
  DELETE_ACTION,
  EDIT_ACTION,
  HEADER_DATE,
  HEADER_DATE_MAJ,
  HEADER_NAME,
  HEADER_RATING,
  HEADER_STATUS,
  PREVIEW_ACTION, STATUS_DRAFT_EXP, STATUS_IN_MODERATION_EXP, STATUS_PUBLISHED_EXP, STATUS_UNPUBLISHED_EXP
} from '../../../../utils/actionsLabels/labels';
import {statusClass} from '../../../../utils/global-constants/experienceStatusColors';
import {NotificationService} from '../../../services/notification.service';
import {
  CREATE_EXPERIENCE_PATH,
  CREATE_TEMPLATE_PATH,
  EXPERIENCE_PATH
} from '../../../../utils/actionsLabels/pathLabels';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {CreateFromExperienceDialogComponent} from '../../popups/create-from-experience-dialog/create-from-experience-dialog.component';

@Component({
  selector: 'app-my-experiences',
  templateUrl: './my-experiences.component.html',
  styleUrls: ['./my-experiences.component.scss']
})
export class MyExperiencesComponent implements OnInit, OnDestroy {

  constructor(private notificationService: NotificationService,
              public dialog: MatDialog,
              private router: Router) {
  }

  @Input() experiences: Experience[];
  @Input() disabledButton;
  @Output() experienceAction = new EventEmitter();
  EDIT_ACTION;
  DELETE_ACTION;
  PREVIEW_ACTION;
  statusClassTab = statusClass;
  tabHeaders = [HEADER_NAME, HEADER_DATE, HEADER_DATE_MAJ, HEADER_RATING, HEADER_STATUS, '', '', ''];
  dialogRef;
  destroyComponent = false;
  statusPublished = STATUS_PUBLISHED_EXP;
  statusUnpublished = STATUS_UNPUBLISHED_EXP;
  statusDraft = STATUS_DRAFT_EXP;
  statusInModeration = STATUS_IN_MODERATION_EXP;

  ngOnInit(): void {
    this.EDIT_ACTION = EDIT_ACTION;
    this.PREVIEW_ACTION = PREVIEW_ACTION;
    this.DELETE_ACTION = DELETE_ACTION;
  }
  ngOnDestroy(): void {
    this.destroyComponent = true;
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  applyAction(val, idExperience, nameExperience) {
    this.experienceAction.emit({data: val, id: idExperience, name: nameExperience});
  }

  comingSoonAction() {
    this.notificationService.showWarning('', COMING_SOON);
  }

  openUseExperience(id) {
    if (this.destroyComponent !== true) { // prevent popup from appearing on other pages
      this.dialogRef = this.dialog.open(CreateFromExperienceDialogComponent, {
        disableClose: false,
        autoFocus: true,
        panelClass: 'my-dialog',
        width: '800px',
        maxHeight: '500px',
      });
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result === 'create template' || result === 'create experience') {
          if (result === 'create template') {
            // go to form create template
            this.router.navigate(
              [CREATE_TEMPLATE_PATH],
              {state: {source: 'experience', idContent: id}}
            ).then();
          } else {
            // go to page create experience
            // this.router.navigateByUrl(CREATE_EXPERIENCE_PATH).then();
            this.router.navigate(
              [CREATE_EXPERIENCE_PATH],
              {state: {source: 'experience', idContent: id}}
            ).then();
          }
        }
      });
    }
  }
  analytics(experience) {
    if(experience.analyticsId != ""){
      window.open("https://analytics.google.com/", "_blank");
    } else {
      this.router.navigateByUrl(EXPERIENCE_PATH + '/' + experience.id+'/edit-analytics')
    }
  }

}
